import { BaseNomenclatorModel } from './base.model';

export class TransportCompanyTypesModel extends BaseNomenclatorModel {
    uid: string;
    id: number ;
    name: string;
}
